import api from './axios';

export const getSummary = (params) => api.get('/dashboard/summary', { params }).then((r) => r.data);
export const getByCustomer = (params) => api.get('/dashboard/by-customer', { params }).then((r) => r.data);
export const getBySalesman = (params) => api.get('/dashboard/by-salesman', { params }).then((r) => r.data);
export const getByProduct = (params) => api.get('/dashboard/by-product', { params }).then((r) => r.data);
export const getByChannel = (params) => api.get('/dashboard/by-channel', { params }).then((r) => r.data);
export const getByMonth = (params) => api.get('/dashboard/by-month', { params }).then((r) => r.data);
export const getTrend = (params) => api.get('/dashboard/trend', { params }).then((r) => r.data);
export const getFilterOptions = (params) => api.get('/dashboard/filter-options', { params }).then((r) => r.data);
export const getBriefReport = (params) => api.get('/dashboard/brief-report', { params }).then((r) => r.data);
